import axiosInstance from "../../utils/axiosConfig";

const axiosBaseQuery = () => async (args, api, extraOptions) => {
  const { url = "", method = "get", data, params } = args || {};

  try {
    const response = await axiosInstance({
      url: url,
      method,
      data,
      params,
    });

    return { data: response.data };
  } catch (error) {
    let err = error;
    if (axiosInstance.isAxiosError?.(error) || error.isAxiosError) {
      err = {
        status: error.response?.status,
        message: error.message,
        data: error.response?.data,
      };
    }
    return { error: err };
  }
};

export default axiosBaseQuery;
